import { render, staticRenderFns } from "./bar-y-percent.vue?vue&type=template&id=3d4d75cb&"
import script from "./bar-y-percent.vue?vue&type=script&lang=js&"
export * from "./bar-y-percent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports